import React from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {AnalyticsScalarMetricsEnum} from '../../../models/api/analyticsMetricsModel';
import {
  AnalyticsFeatureStatusesEnum,
  AnalyticsReportConfig,
  MetricCategoriesEnum,
  ReportElementIdsEnum,
} from './reportTypes';

export function getResolutionsReportConfig(): AnalyticsReportConfig {
  return {
    title: <Trans id="analytics-resolutions-report-title">Resolutions</Trans>,
    reportElements: [
      {
        /* Key Metrics. */
        id: ReportElementIdsEnum.RESOLUTIONS_KEY_METRICS,
        metrics: [
          {
            id: AnalyticsScalarMetricsEnum.AVG_RESPONSE_TIME,
            category: MetricCategoriesEnum.EFFICIENCY,
            isDisplayedByDefault: true,
          },
          {
            id: AnalyticsScalarMetricsEnum.AVG_FIRST_REPLY_TIME,
            category: MetricCategoriesEnum.EFFICIENCY,
            isDisplayedByDefault: true,
          },
          {
            id: AnalyticsScalarMetricsEnum.AVG_HANDLE_TIME,
            category: MetricCategoriesEnum.EFFICIENCY,
            isDisplayedByDefault: true,
          },
        ],
      },
    ],
    options: {},
    featureStatus: AnalyticsFeatureStatusesEnum.NEW,
  };
}
